import * as types from '../types/searchTypes';

const initialState = {
  results: [],
  loading: false,
  error: null,
};

export default function searchReducer(state = initialState, action) {
  switch (action.type) {
    case types.SEARCH_MULTI_REQUEST:
      return { ...state, loading: true, error: null };
    case types.SEARCH_MULTI_SUCCESS:
      return { ...state, loading: false, results: action.payload || [] };
    case types.SEARCH_MULTI_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.SEARCH_CLEAR:
      return { ...state, results: [], error: null };
    default:
      return state;
  }
}
